<template>
  <b-badge
    :style="{
      backgroundColor: resolvedColor,
      color: contrastTextColor,
    }"
    class="status-badge"
  >
    {{ resolvedName }}
  </b-badge>
</template>

<script>
import {
  BBadge,
} from 'bootstrap-vue'
import {
  mapGetters,
} from 'vuex'

const NAMED_COLORS = {
  primary: '#1D4ED8',
  info: '#00cfe8',
  danger: '#ea5455',
  success: '#26aa57',
  warning: '#ff9f43',
  secondary: '#374151',
}

export default {
  name: 'OrderStatusBanner',
  components: {
    BBadge,
  },
  props: {
    statusKey: {
      type: String,
      default: 'N/A',
    },
    color: {
      type: String,
      default: null,
    },
    statusName: {
      type: String,
      default: null,
    },
  },
  computed: {
    ...mapGetters(['statusList']),
    statusFromList() {
      if (!Array.isArray(this.statusList)) return null
      return this.statusList.find(n => n.key === this.statusKey) || null
    },
    resolvedColor() {
      const raw = this.color || (this.statusFromList && this.statusFromList.color) || '#1D4ED8'
      return this.resolveColor(raw)
    },
    resolvedName() {
      if (this.statusName) return this.statusName
      return this.statusFromList ? this.statusFromList.name : 'N/A'
    },
    contrastTextColor() {
      return this.getContrastText(this.resolvedColor)
    },
  },
  methods: {
    resolveColor(color) {
      if (!color || typeof color !== 'string') return '#1D4ED8'
      if (color.startsWith('#')) return color
      return NAMED_COLORS[color.toLowerCase()] || color
    },
    getContrastText(hex) {
      if (!hex || !hex.startsWith('#') || hex.length < 7) return '#fff'
      const r = parseInt(hex.substr(1, 2), 16)
      const g = parseInt(hex.substr(3, 2), 16)
      const b = parseInt(hex.substr(5, 2), 16)
      const yiq = ((r * 299) + (g * 587) + (b * 114)) / 1000
      return yiq >= 160 ? '#1F2937' : '#fff'
    },
  },
}
</script>

<style scoped>
@media (max-width: 767px) { /* Apply the style only for screens up to 767px wide (mobile) */
  .status-badge {
    display: inline-block;
    white-space: normal;
  }
}
</style>
